import React, { Component, Fragment } from 'react';
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader" 
import { Table } from 'elemental-react16'
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea} from "semantic-ui-react"
import shop from "shop/shop"
import ProductTable from "components/Product/ProductTableReturnReadOnly"
import CartTotal from "components/Cart/CartTotal"
import _ from "lodash"
import { Link } from "react-router-dom"
import Spinner                              from "components/Spinner/Spinner"
import Responsive from "react-responsive"
import moment from "moment"
import ReturnPageProgress from './ReturnPageProgress';
import ProductListItem from "components/Product/ProductListItem"

class ReturnPageConfirmation extends Component {

    state = {
        cleanUP: false
    }

    async componentDidMount() {
        await shop.cart.hooks.changed.add( this.updateCart )
        await shop.cart.hydrate()
        await shop.cart.update()
        console.log("RETURN CONFIRMATION MOUNTED, CART: ", shop.cart)
    }

    handleChange = ( { product } ) => {
    let cleanUpValue = true
    product.cleanUpValue = cleanUpValue
    //console.log("HANDLE CHANGE PRODUCT: ", product)
    shop.cart.add( product )
    }
    
    updateCart = () => {
    let products = getProducts()
    products = getProducts()
    //console.log("RETURN UPDATECART: ", products)
    this.setState( { products } )
    this.forceUpdate()
    }
    
    componentWillUnmount() {
    this.setState({productsTemp: shop.cart.products})
    shop.cart.hooks.changed.remove( this.updateCart )
    }

    handleSubmit = async () => {
        //console.log("RETURN HANDLE SUBMIT: ", shop.cart)
        this.setState({cleanUP: true})
        const delay = ms => new Promise(
            resolve => setTimeout(resolve, ms)
          );
        shop.toast( translate( "Bausteinerfassung erfolgt!" ) )

        //console.log("RETURN CURRENT CART: ", shop.cart)
        shop.cart.hooks.changed.add( this.updateCart )
        shop.cart.hydrate()
        shop.cart.update()
        //console.log("FINAL CART CONFIRMATION2: ", shop.cart)
        

		this.props.history.push( "/return/success" )
	}

    render() {
        if(this.state.cleanUP == true){
            return (
                <div className="pa4 pt7 tc">
                    <Spinner size="md" type="inverted"/>
                </div>
            )
        }
        let { pickupdate, contact, comment, email, lieferzeitraum, seasonActive } = shop.cart.data.extras
        console.log("RETURN RENDER: ", pickupdate, contact, comment, email, lieferzeitraum, seasonActive)
        let products = getProducts()
        let bausteinProducts = products.filter( product => !(product.extras && product.extras.additionalArticle) )
        let zusatzsortimentProducts = products.filter( product => product.extras && product.extras.additionalArticle === true )
        return (
            <Fragment>
                <section className="container pt2 pb2">
                    <ReturnPageProgress progress={3} />
                </section>
                <Responsive minWidth={790}>
                <div>
                <Table>
                <colgroup>
                    <col width="10%" />
                    <col width="12%" />
                    <col width="3%" />
                    <col width="55%" />
                </colgroup>
                <tbody>
                    <tr>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                            <ReturnPageHeader className="pt7" activeStep={3} />
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                        <h1 style={{color:"#265a88", fontSize:40}}  className="pt5 tl"><b>Bestellung bestätigen</b></h1>
                            <Message style={{width: "80%", borderRadius: "25px"}} className="tl">
                                <div>Bitte überprüfen Sie Ihre Eingaben auf Vollständigkeit.</div>
                            </Message>
                            <Table style={{width: "80%"}}>
                                <thead>
                                    <tr>
                                        <th>
                                        <p className="pt3"><h2 style={{color:"#265a88", fontSize:22}}>Lieferhinweise</h2></p>
                                        </th>
                                        <th>
                                            &nbsp;
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div >
                                                <p className="fw7">Ansprechpartner</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p>{contact}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div >
                                                <p className="fw7">Lieferzeitraum</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                               {lieferzeitraum}
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <div>
                                                <p className="fw7">E-Mail</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p>{email}</p>
                                            </div>
                                        </td>
                                    </tr>
                                                                        <tr>
                                        <td>
                                            <div>
                                                <p className="fw7">Lieferhinweise</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p>{comment}</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            <br/>
                            {bausteinProducts.length > 0 &&
                            <Table style={{width: "80%"}}>
                                <thead>
                                    <tr>
                                        <th>
                                        <p className="pt3"><h2 style={{color:"#265a88", fontSize:22}}>Baustein</h2></p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {<ProductTable cart={shop.cart} onChange={this.handleChange} products={bausteinProducts} /> }
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>}
                            {zusatzsortimentProducts.length > 0 &&
                            <Table style={{width: "80%"}}>
                                <thead>
                                    <tr>
                                        <th>
                                        <p className="pt3"><h2 style={{color:"#265a88", fontSize:22}}>Zusatzsortiment</h2></p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {<ProductTable cart={shop.cart} onChange={this.handleChange} products={zusatzsortimentProducts} additionalArticle={true}/> }
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>}
                        </td>
                    </tr>

                    <tr>
                    <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            <div style={{paddingTop: "50px",width: "80%"}} className="">
                            <Link to={{
                                pathname: `/return/contactPerson`,
                                search  : this.props.location.search
                            }}>
                                <Button style={{borderRadius: "25px", height: "50px"}}
                                primary >
                                {translate( "Zurück" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                                {<Button style={{borderRadius: "25px", height: "50px"}}
                                    className="fr"
                                    disabled={!seasonActive}
                                    primary
                                    onClick={this.handleSubmit}
                                    >{translate( "Bestellung durchführen" )}</Button> }
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </div>
                </Responsive>
                <Responsive maxWidth={789}>
                <table>
                <colgroup>
                    <col width="90%" />
                </colgroup>
                <tbody>
                    <tr className="bb b--black-10"> 
                        <td>
                        <div className="headerInline"><Button style={{backgroundColor: "#ffffff", maxWidth:"55px"}} 
                            onClick={() => (this.state.navHeader ? this.setState({navHeader : false}) : this.setState({navHeader : true}
                            ))}>
                                <Icon className="big bars tc" ></Icon>
                            </Button><span className="pt3 tc fw7 f2">Baustein</span></div>
                        {this.state.navHeader && <ReturnPageHeader className="v-top" activeStep={2} />}
                        </td>
                        </tr>
                        <tr>
                        <td className="tc pr2  pl2 v-top ReturnPageAlignment" >
                            <h1 style={{color:"#265a88", fontSize:36}}  className="tc"><b>Bestellung bestätigen</b></h1>
                            <Message style={{ borderRadius: "25px"}} className="tl">
                                <div>{translate( "Bitte überprüfen Sie Ihre Eingaben auf Vollständigkeit.")}</div>
                            </Message>
                            <p className="pt3"><h2 style={{color:"#265a88", fontSize:22}}>Erreichbarkeit</h2></p>
                            <table className="pr3 pl3">
                            <colgroup>
                                <col width="25%" />
                                <col width="75%" />
                            </colgroup>
                                <tbody>

                                    <tr className="bb b--black-20">
                                        <td>
                                            <div >
                                                <p className="fw7">Ansprechpartner</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p>{contact}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="bb b--black-20">
                                        <td>
                                            <div >
                                                <p className="fw7">Lieferzeitraum</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                               {lieferzeitraum}
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="bb b--black-20">
                                        <td>
                                            <div>
                                                <p className="fw7">E-Mail</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p>{email}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="">
                                        <td>
                                            <div>
                                                <p className="fw7">Lieferhinweise</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p>{comment}</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    {bausteinProducts.length > 0 && <Fragment>
                    <tr className="">
                        <td>
                            <p className="pt3 tc"><h2 style={{color:"#265a88", fontSize:22}}>Baustein</h2></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <ProductTable cart={shop.cart} onChange={this.handleChange} products={bausteinProducts}/>
                        </td>
                    </tr>
                    </Fragment>}

                    {zusatzsortimentProducts.length > 0 && <Fragment>
                    <tr className="">
                        <td>
                            <p className="pt3 tc"><h2 style={{color:"#265a88", fontSize:22}}>Zusatzsortiment</h2></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <ProductTable cart={shop.cart} onChange={this.handleChange} products={zusatzsortimentProducts} additionalArticle={true}/>
                        </td>
                    </tr>
                    </Fragment>}

                    <tr>
                        <td>
                            <div className="tl pb4">
                            <Link to={{
                                pathname: `/return/contactPerson`,
                                search  : this.props.location.search
                            }}>
                                <Button style={{width: "100px", borderRadius: "25px", height: "50px"	}}
                                primary >
                                {translate( "Zurück" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                                <Button style={{width: "250px", borderRadius: "25px", height: "50px"	}}
                                    className="fr"
                                    disabled={false}
                                    primary
                                    onClick={this.handleSubmit}
                                    >{translate( "Bestellung durchführen" )}</Button>
                            </div>
                        </td>
                    </tr>
                        </tbody>
                        </table>
                </Responsive>
            </Fragment>
        );
    }
}

const getProducts = () => shop.cart.map( ( product ) => product)

export default ReturnPageConfirmation;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/pages/returnCheckout/ReturnPageConfirmation.js